"use client";

import { type ReactNode } from "react";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/layout/app-sidebar";
import { Header } from "@/components/layout/header";
import { MobileNav } from "@/components/layout/mobile-nav";
import { Breadcrumbs } from "@/components/layout/breadcrumbs";
import { ErrorBoundary } from "@/components/shared/error-boundary";
import { useAuth } from "@/providers/auth-provider";
import { PunchoutInterceptor } from "@/components/PunchoutInterceptor";
import { AIAssistant } from "@/components/ai/AIAssistant";

export function DashboardShell({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();

  // Don't render dashboard until auth is confirmed
  if (isLoading || !isAuthenticated) {
    return null;
  }

  return (
    <SidebarProvider>
      <PunchoutInterceptor />
      <AppSidebar />
      <SidebarInset>
        <Header />
        <div className="border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
          <div className="px-4 py-2 md:px-6">
            <Breadcrumbs />
          </div>
        </div>
        <main className="flex-1 overflow-y-auto p-4 pb-20 md:p-6 md:pb-6">
          <ErrorBoundary>
            {children}
          </ErrorBoundary>
        </main>
        <MobileNav />
      </SidebarInset>
      <AIAssistant />
    </SidebarProvider>
  );
}
